<template>
    <Popover v-slot="{ open }">
        <div class="z-0">
            <PopoverButton class="focus-style relative z-0" ref="reference">
                <slot name="button" :open="open" />
            </PopoverButton>
        </div>

        <Teleport to="body">
            <transition
                enter-active-class="transition-opacity duration-200 ease-out"
                enter-from-class="transition-opacity opacity-0"
                enter-to-class="transition-opacity opacity-100"
                leave-active-class="transition-opacity duration-150 ease-in"
                leave-from-class="transition-opacity opacity-100"
                leave-to-class="transition-opacity opacity-0"
            >
                <PopoverPanel
                    class="w-fit top-full -right-1 z-popover"
                    ref="floating"
                    :style="floatingStyles"
                    v-slot="{ close }"
                >
                    <div
                        class="text-nowrap overflow-hidden bg-popover rounded-popover shadow-lg ring-1 ring-border p-2 w-fit"
                    >
                        <slot name="content" :close="close" />
                    </div>
                </PopoverPanel>
            </transition>
        </Teleport>
    </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import { ref } from 'vue'
import {
    useFloating,
    autoUpdate,
    autoPlacement,
    shift,
    offset,
} from '@floating-ui/vue'

export default {
    components: {
        Popover,
        PopoverButton,
        PopoverPanel,
    },

    props: {
        alignEnd: {
            type: Boolean,
            default: true,
        },
    },

    setup(props) {
        const reference = ref(null)
        const floating = ref(null)

        const { floatingStyles } = useFloating(reference, floating, {
            middleware: [
                autoPlacement({
                    allowedPlacements: props.alignEnd
                        ? ['bottom-end', 'top-end']
                        : ['bottom-start', 'top-start'],
                }),
                shift(),
                offset(10),
            ],
            whileElementsMounted: autoUpdate,
        })

        return {
            reference,
            floating,
            floatingStyles,
        }
    },
}
</script>
